import { render, staticRenderFns } from "./correctionSure.vue?vue&type=template&id=d8e76ace&scoped=true"
import script from "./correctionSure.vue?vue&type=script&lang=js"
export * from "./correctionSure.vue?vue&type=script&lang=js"
import style0 from "./correctionSure.vue?vue&type=style&index=0&id=d8e76ace&style=scss&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8e76ace",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d8e76ace')) {
      api.createRecord('d8e76ace', component.options)
    } else {
      api.reload('d8e76ace', component.options)
    }
    module.hot.accept("./correctionSure.vue?vue&type=template&id=d8e76ace&scoped=true", function () {
      api.rerender('d8e76ace', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/policy/customerManage/correctionApplication/correctionSure.vue"
export default component.exports